module.exports = __webpack_public_path__ + "static/media/Wrench.a68b540c.svg";